module.exports = __webpack_public_path__ + "img/logo_bg_white.e5b21547.svg";